module.exports = __webpack_public_path__ + "img/login_bg.36996d83.png";